import React from 'react';
import Button from './Button';

const InputWithButton = props => {
  const { inputProps, buttonProps } = props;

  return (
    <div className="input-with-button">
      <input {...inputProps} />
      <Button {...buttonProps} />
    </div>
  );
};

export default InputWithButton;
